import Swiper from "swiper/bundle";
import "swiper/css/bundle";
// ============================================
// top introduction
// ============================================

function introSlider() {
  const intros = document.querySelectorAll(".js-slider-intro");
  if (intros.length > 0) {
    intros.forEach((intro) => {
      let swiper, swiperbool;
      const breakPoint = 1024;

      if (breakPoint > window.innerWidth) {
        swiperbool = false;
      } else {
        createSwiper();
        swiperbool = true;
      }

      window.addEventListener(
        "resize",
        () => {
          if (breakPoint > window.innerWidth && swiperbool) {
            swiper.destroy(false, true);
            swiperbool = false;
          } else if (breakPoint <= window.innerWidth && !swiperbool) {
            createSwiper();
            swiperbool = true;
          }
        },
        false
      );

      function createSwiper() {
        swiper = new Swiper(intro, {
          //レスポンシブ
          breakpoints: {
            1024: {
              loopAdditionalSlides: 4,

              autoplay: {
                delay: 3000,
                disableOnInteraction: false,
              },
              speed: 1000,
              spaceBetween: 40,
              slidesPerView: 3.3,
            },
          },

          //ページネーションボタン
          pagination: {
            el: ".js-slider-intro__pagination",
            clickable: true,
          },

          //ナビボタン
          navigation: {
            nextEl: ".js-slider-intro__next",
            prevEl: ".js-slider-intro__prev",
          },
          on: {
            init: function () {
              adjustBars(intro);
            },
          },
        });
        function adjustBars(intro) {
          const bars = intro.querySelectorAll(".swiper-pagination-bullet");
          if (!bars.length) return;
          bars.forEach((bar) => {
            bar.style.width = 100 / bars.length + "%";
          });
        }
      }
    });
  }
}

// ============================================
// 物件詳細 mv
// ============================================

function propertyMv() {
  const property = document.querySelector(".js-slider-property");
  if (property) {
    const slideLength = document.querySelectorAll(
      ".p-single-property__mv-slide"
    );
    if (slideLength.length > 1) {
      property.classList.add("swiper");
      new Swiper(property, {
        loop: true,
        observer: true,
        observeParents: true,

        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 1000,
        spaceBetween: 0,
        slidesPerView: 1,

        //ページネーションボタン
        pagination: {
          el: ".js-slider-property__pagination",
          clickable: true,
        },

        //ナビボタン
        navigation: {
          nextEl: ".js-slider-property__next",
          prevEl: ".js-slider-property__prev",
        },
        on: {
          init: function () {
            adjustBars(property);
          },
        },
      });
      function adjustBars(property) {
        const bars = property.querySelectorAll(".swiper-pagination-bullet");
        if (!bars.length) return;
        bars.forEach((bar) => {
          bar.style.width = 100 / bars.length + "%";
        });
      }
    }
  }
}

// ============================================
// 物件詳細 画像部分
// ============================================

function propertyImg() {
  const property = document.querySelector(".js-slider-property__img");
  if (property) {
    const slideLength = property.querySelectorAll(".swiper-slide");
    const num = document.querySelector(".js-num").textContent;
    const contents = property.querySelector(
      ".p-single-property__img-sliderWrap"
    );
    console.log(slideLength.length);
    if (slideLength.length === 1) {
      property.classList.add("swiper");
      contents.classList.add("-slide01");
    } else if (slideLength.length === 2) {
      contents.classList.add("-slide02");
    }

    if (slideLength.length > 1) {
      new Swiper(property, {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 1000,
        spaceBetween: 10,
        slidesPerView: 1.2,
        //レスポンシブ
        breakpoints: {
          768: {
            spaceBetween: 10,
            slidesPerView: 2.1,
          },
          1024: {
            spaceBetween: 40,
            slidesPerView: num,
          },
        },

        //ナビボタン
        navigation: {
          nextEl: ".js-slider-property__next",
          prevEl: ".js-slider-property__prev",
        },
        on: {
          init: function () {
            adjustBars(property);
          },
        },
      });
      function adjustBars(property) {
        const bars = property.querySelectorAll(".swiper-pagination-bullet");
        if (!bars.length) return;
        bars.forEach((bar) => {
          bar.style.width = 100 / bars.length + "%";
        });
      }
    }
  }
}

// ============================================
// 物件詳細 関連記事
// ============================================

function archiveSlider() {
  const archives = document.querySelectorAll(".js-slider-archive");
  if (archives.length > 0) {
    archives.forEach((archive) => {
      const slideLength = document.querySelectorAll(".c-card01");
      if (slideLength.length > 1) {
        archive.classList.add("swiper");
        let swiper, swiperbool;
        const breakPoint = 1024;

        if (breakPoint > window.innerWidth) {
          swiperbool = false;
        } else {
          createSwiper();
          swiperbool = true;
        }

        window.addEventListener(
          "resize",
          () => {
            if (breakPoint > window.innerWidth && swiperbool) {
              swiper.destroy(false, true);
              swiperbool = false;
            } else if (breakPoint <= window.innerWidth && !swiperbool) {
              createSwiper();
              swiperbool = true;
            }
          },
          false
        );

        function createSwiper() {
          swiper = new Swiper(archive, {
            //レスポンシブ
            breakpoints: {
              1024: {
                loop: true,

                autoplay: {
                  delay: 3000,
                  disableOnInteraction: false,
                },
                speed: 1000,
                spaceBetween: 40,
                slidesPerView: 3.5,
              },
            },

            //ページネーションボタン
            pagination: {
              el: ".js-slider-archive__pagination",
              clickable: true,
            },

            //ナビボタン
            navigation: {
              nextEl: ".js-slider-archive__next",
              prevEl: ".js-slider-archive__prev",
            },
            on: {
              init: function () {
                adjustBars(archive);
              },
            },
          });
          function adjustBars(archive) {
            const bars = archive.querySelectorAll(".swiper-pagination-bullet");
            if (!bars.length) return;
            bars.forEach((bar) => {
              bar.style.width = 100 / bars.length + "%";
            });
          }
        }
      }
    });
  }
}

export { introSlider, propertyMv, propertyImg, archiveSlider };
